export var getTimelineDetails = function (timelineDetails) {
    var details = [];
    timelineDetails.map(function (item, index) {
        var _a, _b;
        details.push({
            header: (_a = item.status) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.status,
            status: item.statusType ? (_b = item.statusType) === null || _b === void 0 ? void 0 : _b.toLowerCase() : "",
            description: item === null || item === void 0 ? void 0 : item.dpStatusTime,
        });
    });
    return details;
};
